import GenericFilter from "@/components/Filters/GenericFilter";
import { getBattlePowerData } from "@/components/DeckBuilder/game/unionArena/filterPossibleValues";
import { FaFistRaised } from "react-icons/fa";

export default function BattlePowerFilter({
  selected,
  setSelected,
}: {
  selected: Set<any>;
  setSelected: (selectedOptions: Set<string>) => void;
}) {
  let data = getBattlePowerData();

  return (
    <GenericFilter
      classNames="w-[100px]"
      selected={selected}
      setSelected={setSelected}
      startContent={<FaFistRaised className="h-[14px]" />}
      selectionMode="single"
      label="BP"
      data={data}
    />
  );
}
